import Vue from "vue";
import App from "./App";
import router from "./router/index";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import store from './store';
import VueNativeNotification from 'vue-native-notification';
import StarRating from 'vue-star-rating'
import { Datetime } from 'vue-datetime';
import { JitsiMeet } from "@mycure/vue-jitsi-meet";
import 'vue-datetime/dist/vue-datetime.css'
Vue.component('datetime', Datetime);
import VueMask from 'v-mask'
Vue.use(VueMask);
Vue.use(PaperDashboard);
//CARDS
import Tabs from "@/components/Tabs";
import Contents from "@/components/Contents";
import FieldsList from "@/components/Item/FieldsList";
import CardItem from '@/components/Item/CardItem'

Vue.component('location', () => import("@/components/Location"));
Vue.component('role', () => import("@/components/Role"));

//FLOWS
Vue.component('flow-certificate', () => import("@/components/Item/_flow/FlowCertificate"));
Vue.component('flow-trade-in', () => import("@/components/Item/_flow/FlowTradeIn"));
Vue.component("VueJitsiMeet", JitsiMeet);
Vue.component('img-upload', () => import("@/components/Inputs/ImgUpload"));
Vue.component('img-upload-base64', () => import("@/components/Inputs/ImgUploadBase64"));
Vue.component('external-informator', () => import("@/components/ExternalInformator"));
Vue.component('external-select', () => import("@/components/ExternalSelect"));
Vue.component('map-set', () => import("@/components/Inputs/Map"));
Vue.component('set-language', () => import("@/components/SetLanguage"));
Vue.component('zip-upload', () => import("@/components/Inputs/zipUpload"));
Vue.component('zip-upload-button', () => import("@/components/Inputs/zipUploadButton"));
Vue.component('tags', () => import("@/components/Tags"));
Vue.component('images', () => import("@/components/Images"));
Vue.component('bts-statuses', () => import("@/components/Services/bts/references/statuses"));
Vue.component('info', () => import("@/components/Info"));
Vue.component('transaction-chat', () => import("@/components/TransactionChat"));
Vue.component('selectors', () => import("@/components/Inputs/Selectors"));
Vue.component('radio-list', () => import("@/components/Filters/RadioList"));
Vue.component('selector', () => import("@/components/Inputs/Selector"));
Vue.component('language-list', () => import("@/components/Filters/LanguageList"));
Vue.component('post-content', () => import("@/components/Post/PostContent"));
Vue.component('post-open', () => import("@/components/Post/PostOpen"));
Vue.component('gallery', () => import("@/components/Modals/Gallery"));
Vue.component('add-video', () => import("@/components/Modals/AddVideo"));
Vue.component('tabs', Tabs);
Vue.component('FieldsList', FieldsList);
Vue.component('Contents', Contents);
Vue.component('card-item', CardItem);
Vue.component('filter-item', () => import('@/components/Filter'));
Vue.component('list', () => import('@/components/List'));
Vue.component('star-rating', StarRating)
let items = store.state.items;
Object.keys(items).forEach(key => {
  // console.log(items[key]);
  Vue.component(key, () => import(`@/components/Item/${items[key]}/index`));
});


import VueEcho from 'vue-echo-laravel';


try {
  Vue.use(VueEcho, {
    broadcaster: 'socket.io',
    host: window.location.hostname + ':6001',
  });
} catch (error) {

}

try {
  Notification.requestPermission()
    .then(() => {
    });
  Vue.use(VueNativeNotification, {
    requestOnNotify: true
  });
} catch (error) {

}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
